import type { RouteObject } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import Home from '@/pages/home/page';
import BlacklistCategory from '@/pages/category/blacklist/page';
import NewsCategory from '@/pages/category/news/page';
import Detail from '@/pages/detail/page';
import Search from '@/pages/search/page';
import About from '@/pages/about/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'category/blacklist', element: <BlacklistCategory /> },
      { path: 'category/news', element: <NewsCategory /> },
      { path: 'detail/:id', element: <Detail /> },
      { path: 'search', element: <Search /> },
      { path: 'about', element: <About /> },
      { path: '*', element: <NotFound /> },
    ],
  },
];

export default routes;